<div class="wrap">
  <div class="title">
    <mat-icon aria-hidden="true">warning_amber</mat-icon>
    <span>Confirm swipe left</span>
  </div>

  <div class="msg">{{ data.message }}</div>

  <div class="actions">
    <button mat-button type="button" (click)="cancel($event)">Wait, no</button>
    <button mat-raised-button color="warn" type="button" (click)="confirm($event)">Yes, pass</button>
  </div>
</div>

